/** * アプリ情報 */
<template>
  <ifield-b-modal
    id="application-information-dialog"
    v-bind:title="$t('theApplicationInformation.applicationInformation')"
    centered
    scrollable
    size="md"
    ok-only
    ok-variant="success"
    v-bind:ok-title="$t('theApplicationInformation.action.confirm')"
  >
    <div class="dialog-body-text">
      <p class="text">{{ planNameText }}</p>
      <p class="text">{{ versionText }}</p>
      <p class="text">{{ companyCodeText }}</p>
    </div>
  </ifield-b-modal>
</template>

<script>
export default {
  name: 'TheApplicationInformation',
  computed: {
    /**
     * プラン名
     * @type {String}
     */
    planName: function () {
      return this.$store.state.login.appType
    },
    /**
     * 企業コード
     * @type {String}
     */
    companyCode: function () {
      return this.$store.state.login.companyCode
    },
    /**
     * プラン名表示文字列
     * @type {String}
     */
    planNameText: function () {
      return (
        this.$t('theApplicationInformation.planName') + ' : ' + this.planName
      )
    },
    /**
     * 企業コード表示文字列
     * @type {String}
     */
    companyCodeText: function () {
      return (
        this.$t('theApplicationInformation.companyCode') +
        ' : ' +
        this.companyCode
      )
    },
    /**
     * バージョン表示文字列
     * @type {String}
     */
    versionText: function () {
      return (
        this.$t('theApplicationInformation.version') +
        ' : ' +
        process.env.VUE_APP_VERSION
      )
    },
  },
  mounted: function () {
    this.$log.info('TheAppInfo mounted.')
  },
  methods: {
    /**
     * ダイアログを表示する
     * @public
     */
    showModal: function () {
      this.$bvModal.show('application-information-dialog')
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-body-text {
  padding: 16px;
  font-size: $font-size-middle;

  .text {
    margin-bottom: 0;
    line-height: 2.25;
  }
}
</style>
